import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  team: undefined,
  color: "",
  type: "",
};

const teamsSlice = createSlice({
  name: "teams",
  initialState,
  reducers: {
    selectedTeam: (state, action) => {
      state.team = action.payload;
    },
    updateAssings: (state, action) => {
      state.selected.assigns = action.payload;
    },
    changeColor(state, action) {
      state.color = action.payload;
    },
    changeType(state, action) {
      state.type = action.payload;
    },
    setTeamTitle(state, action) {
      state.title = action.payload
    }
  },
});

export const { selectedTeam, updateAssings, changeColor, changeType, setTeamTitle } =
  teamsSlice.actions;
export default teamsSlice.reducer;
